import { Box } from "@mui/material";

import { IUploadHistory } from "./Governance.types";
import { GovernanceUploadTable } from "./GovernanceUpload.Table";

type GovernanceUploadSummaryProps = {
  /** Undefined antes da primeira carga: métricas em zero e tabela vazia. */
  upload?: IUploadHistory;
};

/**
 * Parte comum entre a aba Atividade e o detalhe de um upload do histórico: os cartões de métrica
 * e a tabela. O cabeçalho difere entre as duas telas, então fica em cada uma.
 */
export function GovernanceUploadSummary({ upload }: GovernanceUploadSummaryProps) {
  /** As colunas `total_*` são nullable no banco, então `null` cai em zero. */
  const metrics = [
    { label: "Total de beneficiários", value: upload?.totalRows ?? 0 },
    { label: "Beneficiários atualizados", value: upload?.totalUpserts ?? 0 },
    { label: "Beneficiários criados", value: upload?.totalInserts ?? 0 },
    { label: "Beneficiários removidos", value: upload?.totalRejected ?? 0 },
  ];

  return (
    <Box sx={{ width: "100%" }}>
      <div style={{ width: "100%", display: "flex", flexDirection: "row", gap: "16px" }}>
        {metrics.map((metric) => (
          <div
            key={metric.label}
            style={{ width: "100%", border: "solid 1px #E8E8E8", borderRadius: "16px", padding: "16px", display: "flex", flexDirection: "column" }}
          >
            <p style={{ fontSize: "12px", lineHeight: "20px", color: "#6F6F78" }}>{metric.label}</p>
            <span style={{ fontSize: "20px", lineHeight: "32px", fontWeight: "600", color: "#6F6F78" }}>{metric.value}</span>
          </div>
        ))}
      </div>

      <Box sx={{ marginTop: "24px" }}>
        <GovernanceUploadTable data={upload?.beneficiaries ?? []} />
      </Box>
    </Box>
  );
}
